import { render } from "./JobNotificationGeneric.vue?vue&type=template&id=f298f400"
import script from "./JobNotificationGeneric.vue?vue&type=script&lang=js"
export * from "./JobNotificationGeneric.vue?vue&type=script&lang=js"

import exportComponent from "/app/tmp/blackhall/V3/v2026.26.r3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__